export default "__VITE_ASSET__BzkcA6km__"